import './noData.scss'
import empty from 'img/layout/empty.webp'
export const NoData = () => {
    return(
        <div className={'w100 h100 show-flex-box-c show-flex-center no-data-wrap'}>
            <img className={'no-data-img'} src={empty} alt=""/>
            <div className={'no-data-label'}>No Data</div>
        </div>
    )
}